export default {"src":"/_next/static/media/0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F.7e5fc63f.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};